import { z } from 'zod';

const extraSchema = z.record(z.string(), z.any());

export const automataLogSchema = z.object({
  id: z.number().optional(),
  message_type: z.string(),
  timestamp: z.string(),
  level: z.number(),
  territory_provider_identifier: z.number(),
  vehicle_provider_identifier: z.string(),
  message: z.string(),
  extra: extraSchema,
});
export const vehicleLogSchema = z.object({
  id: z.number().optional(),
  vehicle_id: z.string(),
  start_datetime: z.string(),
  level: z.string(),
  context: extraSchema,
  code: z.string(),
  description: z.string(),
  category: z.string(),
});
export const automataLogStatisticsSchema = z.object({
  timestamp: z.string(),
  territory_provider_identifier: z.string(),
  vehicle_provider_identifier: z.string(),
  level: z.string(),
  message: z.string(),
  extra: z.record(z.string(), z.any()),
});
export const doorStatusSchema = z.object({
  received_at: z.string(),
  door_status: z.string(),
});

export type AutomataLog = z.infer<typeof automataLogSchema>;
export type VehicleLog = z.infer<typeof vehicleLogSchema>;
export type AutomataLogStatistics = z.infer<typeof automataLogStatisticsSchema>;
export type DoorStatus = z.infer<typeof doorStatusSchema>;
